import { Dispatch } from 'redux';

import types from 'redux/actions/actionTypes';
import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';

export const getAiConversations =
  (societyId: string) => async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get('/ai/conversations', {
        params: { societyId },
      });
      const decoded: any = await decryptResponse(data);
      dispatch({ type: types.GET_AI_CONVERSATIONS, conversations: decoded });
      return decoded;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };

export const getAiConversation =
  (conversationId: string) => async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get(`/ai/conversations/${conversationId}`);
      const decoded: any = await decryptResponse(data);
      dispatch({ type: types.GET_AI_CONVERSATION, conversation: decoded });
      return decoded;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };

export const deleteAiConversation =
  (conversationId: string) => async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.delete(
        `/ai/conversations/${conversationId}`
      );
      const decoded: any = await decryptResponse(data);
      dispatch({
        type: types.DELETE_AI_CONVERSATION,
        conversationId: decoded?.id,
      });
      return decoded;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };

export const getAiUsage =
  (societyId: string) => async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get('/ai/usage', {
        params: { societyId },
      });
      const decoded: any = await decryptResponse(data);
      dispatch({ type: types.SET_AI_USAGE, usage: decoded });
      return decoded;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };

export const clearAiConversation = () => ({
  type: types.CLEAR_AI_CONVERSATION,
});

export const appendAiMessage = (message: {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  createdAt?: string;
}) => ({
  type: types.APPEND_AI_MESSAGE,
  message,
});
